import React from "react";
import styles from "./financialMarket.module.css";

const FinancialMarket = () => {
  return (
    <section className={styles.marketSection}>
      <div className={styles.marketContainer}>
        <h2 className={styles.marketHeading}>
          Explore the <span>Financial Markets</span>
        </h2>
        <p className={styles.marketSub}>
          Trade across multiple asset classes with institutional-grade tools and competitive spreads.
        </p>

        <div className={styles.marketGrid}>
          {/* Forex Card */}
          <div className={styles.marketCard}>
            <div className={styles.cardIcon}>
              <div className={styles.forexIcon}></div>
            </div>
            <h3>Forex</h3>
            <p>Access 70+ major, minor and exotic currency pairs with spreads from 0.0 pips and lightning-fast execution.</p>
            <button className={styles.cardButton}>Start Trading</button>
          </div>

          {/* Commodities Card */}
          <div className={styles.marketCard}>
            <div className={styles.cardIcon}>
              <div className={styles.commoditiesIcon}></div>
            </div>
            <h3>Commodities</h3>
            <p>Trade gold, silver, oil, and agricultural products with real-time pricing and deep market liquidity.</p>
            <button className={styles.cardButton}>Start Trading</button>
          </div>

          {/* Indices Card */}
          <div className={styles.marketCard}>
            <div className={styles.cardIcon}>
              <div className={styles.indicesIcon}></div>
            </div>
            <h3>Indices</h3>
            <p>Invest in global stock indices including S&P 500, NASDAQ, FTSE, and more with competitive spreads.</p>
            <button className={styles.cardButton}>Start Trading</button>
          </div>

          {/* Crypto Card */}
          <div className={styles.marketCard}>
            <div className={styles.cardIcon}>
              <div className={styles.cryptoIcon}></div>
            </div>
            <h3>Cryptocurrency</h3>
            <p>Trade Bitcoin, Ethereum, and 50+ cryptocurrencies with 24/7 market access and secure custody.</p>
            <button className={styles.cardButton}>Start Trading</button>
          </div>

          {/* ✅ NEW: Stocks Card */}
          <div className={styles.marketCard}>
            <div className={styles.cardIcon}>
              <div className={styles.stocksIcon}></div>
            </div>
            <h3>Stocks</h3>
            <p>Trade shares of leading global companies like Apple, Tesla, Microsoft with zero commissions and fractional shares.</p>
            <button className={styles.cardButton}>Start Trading</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinancialMarket;
